import React from 'react'
import { node, string, func, bool } from 'prop-types'
import styled from 'styled-components'
import { stripUnit, rgba } from 'polished'

import { white, borderColor } from 'styles/colors'
import { animationTime, animationCurve } from 'styles/global'
import { fontWeights, H3 } from 'styles/typography'
import * as spacing from 'styles/spacing'
import { media } from 'styles/media'
import Icon from 'components/Icon'

import DownChevron from 'icons/down-chevron.svg'

const Container = styled.div`
  position: relative;

  & + & {
    border-top: 1px solid ${rgba(borderColor, 0.15)};
  }
`

const Trigger = styled.button`
  display: flex;
  width: 100%;
  text-align: left;
  color: ${white};
  padding: ${stripUnit(spacing.medium) * 1.25 + 'px'} 0;

  ${media.medium`
    padding: ${spacing.large} 0;
    padding-right: ${spacing.large};
  `};
`

const Title = styled(H3)`
  flex-grow: 1;
  padding-right: ${spacing.medium};
  margin-bottom: 0;
  color: ${white};
  font-weight: ${fontWeights.regular};

  ${media.medium`
    padding-right: ${spacing.large};
  `};
`

const Chevron = styled.div`
  display: flex;
  flex-shrink: 0;
  transition: color ${animationTime} ${animationCurve}, transform ${animationTime} ${animationCurve};
  transform: ${props => (props.flipped ? 'rotate(180deg)' : 'none')};
`

const Content = styled.div`
  position: static;
  border-top: 1px solid ${rgba(borderColor, 0.15)};
  padding: ${stripUnit(spacing.medium) * 1.25 + 'px'} 0;

  ${media.medium`
    padding: ${spacing.large} 0;
  `};
`

const FaqCategory = ({ title, expanded, handleClick, children }) => (
  <Container>
    <Trigger onClick={handleClick}>
      <Title>{title}</Title>
      <Chevron flipped={expanded ? 'true' : undefined}>
        <Icon icon={<DownChevron />} />
      </Chevron>
    </Trigger>
    {expanded ? <Content>{children}</Content> : null}
  </Container>
)

FaqCategory.propTypes = {
  children: node.isRequired,
  title: string.isRequired,
  expanded: bool,
  handleClick: func.isRequired
}

export default FaqCategory
